import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { TReviewDetail } from 'types/UserReviews';
import UserReviewsListItem from './UserReviewsListItem';

import Classes from './UserReviewsList.scss';

type TUserReviewsListProps = {
  reviews: TReviewDetail[];
};

const UserReviewsList = ({ reviews }: TUserReviewsListProps) => {
  const { t } = useI18nContext();

  return (
    <div>
      <h5 className={Classes.title}>{t('userReviews.reviewsByOthers')}</h5>

      <ul className={Classes.list}>
        {reviews.map((review) => (
          <UserReviewsListItem key={review.id} review={review} />
        ))}
      </ul>
    </div>
  );
};

export default UserReviewsList;
